import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { AuthLayout } from "@/pages/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useApp } from "@/context/AppContext";

export default function Login() {
  const { activate } = useApp();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", code: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await activate({ email: form.email, code: form.code });
    setLoading(false);
    if (res.error) return toast.error(res.error);
    toast.success("Akses aktif. Selamat datang di Scholavia!");
    navigate(res.entitled ? "/app" : "/akses");
  };

  return (
    <AuthLayout
      title="Masuk ke Scholavia"
      subtitle="Masukkan email pembelian dan kode akses yang dikirim ke emailmu."
      footer={<>Belum punya akses? <a href="https://lynk.id/scholavia/ne6kpwmkr1km" target="_blank" rel="noopener noreferrer" className="font-semibold text-[#7C3AED] hover:underline">Beli di Lynk.id</a></>}
    >
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="email">Email Pembelian</Label>
          <Input id="email" type="email" required data-testid="login-email" placeholder="kamu@email.com" value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5" />
        </div>
        <div>
          <Label htmlFor="code">Kode Akses</Label>
          <Input id="code" type="text" required data-testid="login-code" placeholder="SCH-XXXX-XXXX" value={form.code}
            onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} className="mt-1.5 tracking-widest" />
          <p className="mt-1.5 text-xs text-slate-400">Kode dikirim otomatis ke emailmu setelah pembayaran di Lynk.id berhasil.</p>
        </div>
        <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full rounded-xl bg-[#7C3AED] py-5 text-base hover:bg-[#6D28D9]">
          {loading ? "Memproses…" : "Masuk"}
        </Button>
      </form>
    </AuthLayout>
  );
}
